import React, { useEffect, useState } from 'react';
import useAxiosFetchApi from '../../hooks/useFetch';
import { useAuth } from '../../hooks/appHooks';
import { FaPen, FaTrash } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import AppLoading from '../../utils/AppLoading';
import EditModal from '../modals/EditModal';
import ConfirmationModal from '../modals/ConfirmationModal';
import AddOrEditUser from '../vendor/AddOrEditUser';
import useAxiosPrivate from '../../apis/useAxiosPrivate';
import { useLocation } from 'react-router-dom';
import AddOrEditAdminUser from './AddOrEditUser';
import { Edit, Trash } from 'iconsax-reactjs';
import Tooltip from '../../utils/Tooltip';
import EditUser from './EditUser';
import SwitchInput from '../../components/SwitchInput';
import EditCustomer from './EditCustomer';

const FETCH_USERS_URL = "/users/admin/users";
const USER_DELETE_URL = "/users/delete";

const CustomersList = ({ routeRole }) => {
    const { auth, setAuth } = useAuth();
    const { t, i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    const tUserInfo = t("vendorFormInfo");

    const vendor = location?.state?.vendor;
    const [editModal, setShowEditModal] = useState({ user: null, status: false });

    const [deleteModal, setShowDeleteModal] = useState({ userId: null, status: false });
    const [searchQuery, setSearchQuery] = useState('');
    const sessionToken = auth.token;
    const [state, setUrl, setChangeData] = useAxiosFetchApi(null, {}, sessionToken);

    useEffect(() => {
        setUrl(FETCH_USERS_URL);
    }, [setUrl]);

    useEffect(() => {
        if (routeRole === "SUPERADMIN") {
            setAuth((prev) => ({ ...prev, vendor: null }))
        }
    }, [vendor, setAuth, routeRole]);

    const customersList = state.data?.data?.list;

    const handleOnUserDelete = async (userId) => {
        try {
            const userDeletedResponse = await axiosPrivate.delete(USER_DELETE_URL + `/${userId}`,
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
            );
            const otherUsers = customersList?.filter(user => user.customer.userId !== userId);
            setChangeData({ list: otherUsers });
            toast.success(userDeletedResponse?.data.message);
        } catch (error) {
            toast.error(error.response?.data.message);
        }
    };

    function onSetChangedData(cust) {
        const otherUsers = customersList?.filter(({ customer }) => {
            console.log('customer: ', customer);

            return customer.customerId !== cust.customerId

        });
        setChangeData({ list: [...otherUsers || {}, { message: null, customer: cust }] });

        console.table({ customersList, otherUsers, dataChange: { list: [...otherUsers || {}, { message: null, customer: cust }] } });

    }

    const queryUsers = customersList?.filter(({ customer }) =>
        Object.values(customer).some((value) =>
            value != null && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    return (
        <>
            <ToastContainer />
            <div className='flex flex-col w-full'>
                <div className="flex justify-between mb-10">
                    <h2>{tUserInfo.users}</h2>
                </div>
                <div className="flex flex-col shadow-3 p-2 rounded-2xl">
                    <div className="flex justify-between">
                        <input
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            type="text" placeholder={t("search")} className='p-2 m-2 rounded-lg border' />
                    </div>
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 px-6">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead className="bg-neutral-100 rounded-lg font-medium dark:border-neutral-500 dark:text-neutral-800">
                                        <tr>
                                            <th scope="col" className="py-4">{tUserInfo.email?.label.replace("*", "")}</th>
                                            <th scope="col" className="py-4">{tUserInfo.phone?.label.replace("*", "")}</th>
                                            <th scope="col" className="py-1">{t("action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state.isLoading ? <tr><td colSpan={4} className='p-10'>
                                            <AppLoading />
                                        </td></tr>
                                            : !customersList
                                                ? <tr><td colSpan={4} className='p-10'>{state.data?.message ?? state.error?.message}</td></tr>
                                                : queryUsers?.length === 0
                                                    ? <tr><td colSpan={4} className='p-10'>{tUserInfo.noUsers}</td></tr>
                                                    : queryUsers.map(({ customer }) => (
                                                        <tr key={customer.customerId}>
                                                            <td className="whitespace-nowrap py-4 font-medium">{customer.email}</td>
                                                            <td className="whitespace-nowrap py-4">{customer.phone}</td>
                                                            <td className="whitespace-nowrap py-4 w-1/4">
                                                                <div className="w-full flex items-center gap-1 justify-center">

                                                                    <Tooltip text={tUserInfo.blockBtn.toLowerCase()}>
                                                                        <SwitchInput currentUser={customer} onSetChangedData={onSetChangedData} />
                                                                    </Tooltip>

                                                                    <Tooltip text={tUserInfo.editBtn.toLowerCase()}>
                                                                        <Edit
                                                                            size={26}
                                                                            className='text-gray-400 cursor-pointer mx-1 hover:text-primary transition-colors duration-200 ease-in'
                                                                            variant="Bulk"
                                                                            onClick={() => setShowEditModal({ customer: customer, status: true })}
                                                                        />
                                                                    </Tooltip>


                                                                    <Tooltip text={tUserInfo.deleteBtn.toLowerCase()}>
                                                                        <Trash
                                                                            className="text-gray-500 cursor-pointer mx-1 hover:text-red-600 transition-colors duration-200 ease-in"
                                                                            variant="Bulk"
                                                                            onClick={() => setShowDeleteModal({ userId: customer.userId, status: true })}
                                                                        />
                                                                    </Tooltip>

                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditModal showModal={editModal.status} setShowModal={setShowEditModal} target={tUserInfo[editModal.user != null ? "editUserTitle" : "addUserTitle"]}>
                <EditCustomer
                    key={editModal.user?.userId}
                    isEdit={editModal.user != null}
                    onChangeData={onSetChangedData}
                    currentUser={editModal.user}
                    setShowEditModal={setShowEditModal}
                />
            </EditModal>

            <ConfirmationModal
                title={"Confirm User Delete"}
                btnColor={"bg-danger"}
                message={"Are you sure you want to delete this user?"}
                onAction={() => { handleOnUserDelete(deleteModal.userId); setShowDeleteModal({ ...deleteModal, status: false }) }}
                showModal={deleteModal.status}
                setShowModal={setShowDeleteModal} />
        </>
    );
};

export default CustomersList;